import React, { Component } from "react";
import { FormGroup, FormControlLabel } from "material-ui/Form";
import Checkbox from "material-ui/Checkbox";
import Button from "material-ui/Button";
import Typography from "material-ui/Typography";

export default class QuestionKeywords extends Component {
  iMinSelect = 7;
  iCurrentQuestionID = 0;
  iChecked = 0;

  constructor(props) {
    super(props);

    const { oQuestion } = this.props;

    this.state = {
      checkboxes: this.getTheCheckBoxes(oQuestion),
      iChecked: this.iChecked
    };

    this.iCurrentQuestionID = oQuestion.id;

    this.handleNextQuestion = this.handleNextQuestion.bind(this);
    this.renderAnswer = this.renderAnswer.bind(this);

    this.keyCount = 0;
    this.getKey = this.getKey.bind(this);
  }

  /**
   * Returns the correct checkboxes
   * @param oQuestion
   * @returns {Array}
   */
  getTheCheckBoxes(oQuestion) {
    let theCheckBoxes = [];

    if (Object.keys(oQuestion.givenAnswers).length > 0) {
      theCheckBoxes = oQuestion.givenAnswers;

      //Reset state and check how much are selected
      Object.keys(theCheckBoxes).forEach(key => {
        let value = theCheckBoxes[key];
        if (value.checked === true) {
          this.iChecked++;
        }
      });
    } else {
      let shuffledArray = shuffleArray(oQuestion.answers);

      shuffledArray.forEach(oAnswer => {
        oAnswer.checked = false;
        theCheckBoxes["checkbox" + oAnswer.id] = oAnswer;
      });
    }

    return theCheckBoxes;
  }

  /**
   * Returns a unique key for each components
   * @returns {number}
   */
  getKey() {
    return this.keyCount++;
  }

  /**
   * Answer and go to next window
   */
  handleNextQuestion() {
    this.props.onAnswerQuestion(this.state.checkboxes);
  }

  /**
   * Handle the checkbox state when clicked
   * @param oAnswer, event
   */
  handleChange = oAnswer => event => {
    let oCheckBoxes = this.state.checkboxes;

    //map function doesn't work because the keys have a name
    Object.keys(oCheckBoxes).forEach(key => {
      let value = oCheckBoxes[key];

      if (value.id === oAnswer.id) {
        if (value.checked === true && this.iChecked >= this.iMinSelect) {
          event.target.checked ? this.iChecked++ : this.iChecked--;
          value.checked = event.target.checked;
        } else if (this.iChecked >= this.iMinSelect) {
          return false;
        } else {
          event.target.checked ? this.iChecked++ : this.iChecked--;
          value.checked = event.target.checked;
        }
      }
    });

    this.setState({ checkboxes: oCheckBoxes, iChecked: this.iChecked });
  };

  /**
   * Returns whether the checkbox for the given answer should be disabled.
   *
   * @param {Object} answer
   * @returns {boolean}
   */
  isCheckboxDisabled(answer) {
    for (const key of Object.keys(this.state.checkboxes)) {
      const checkbox = this.state.checkboxes[key];
      if (checkbox.id === answer.id) {
        return this.iChecked >= this.iMinSelect && checkbox.checked !== true;
      }
    }
    return false;
  }

  /**
   * Render the question as component
   * @param oAnswer
   * @returns {XML}
   */
  renderAnswer(oAnswer) {
    const styles = {
      marginLeft: "5px",
      textAlign: "center"
    };

    let sCurrentCheckbox = "checkbox" + oAnswer.id;

    return (
      <div className="col-6" key={this.getKey()}>
        <FormGroup style={styles} row>
          <FormControlLabel
            disabled={this.isCheckboxDisabled(oAnswer)}
            control={
              <Checkbox
                checked={this.state.checkboxes[sCurrentCheckbox].checked}
                onChange={this.handleChange(oAnswer)}
                value=""
                color="primary"
              />
            }
            label={oAnswer.answer}
          />
        </FormGroup>
      </div>
    );
  }

  /**
   * Main render function
   * @returns {XML}
   */
  render() {
    const { oQuestion } = this.props;

    if (this.iCurrentQuestionID !== oQuestion.id) {
      this.iChecked = 0;
      let aCheckBoxes = this.getTheCheckBoxes(oQuestion);
      this.setState({
        checkboxes: aCheckBoxes,
        iChecked: this.iChecked
      });

      this.iCurrentQuestionID = oQuestion.id;
    }

    return (
      <section className="section QuestionSingleChoice">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <Typography
                variant="headline"
                style={{ fontSize: "18px", marginTop: "5px" }}
              >
                {oQuestion.question}
              </Typography>
              <Typography
                component="p"
                style={{ marginTop: "15px", marginBottom: "15px" }}
              >
                You still need to select{" "}
                {this.iMinSelect - this.state.iChecked} keywords to continue
              </Typography>
            </div>
          </div>
          <div className="row keywords">
            {oQuestion.answers.map(oAnswer => {
              return this.renderAnswer(oAnswer);
            })}
          </div>
          <div className="row">
            <div className="col-12">
              <Button
                variant="raised"
                onClick={this.handleNextQuestion}
                disabled={this.state.iChecked >= this.iMinSelect ? false : true}
                color="primary"
              >
                NEXT
              </Button>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

/**
 * Shuffles a array
 * @param {Array} array
 * @returns {Array}
 */
function shuffleArray(array) {
  var currentIndex = array.length,
    temporaryValue,
    randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}



// WEBPACK FOOTER //
// ./src/components/QuestionKeywords.jsx